import {useState} from 'react';
import {BlockStack, Button, Modal, Text} from './admin-ui';
import {t} from '../localization/adminText';

export default function AddCodFormToTheme({disabled = false, beforeOpen}) {
  const [open, setOpen] = useState(false);
  const shop = window.shopify?.config?.shop || new URLSearchParams(window.location.search).get('shop') || new URLSearchParams(window.location.search).get('shop_domain') || '';
  const apiKey = document.querySelector('meta[name="shopify-api-key"]')?.content || '';
  const available = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop) && /^[a-f0-9]{32}$/i.test(apiKey);
  const editor = available ? `https://${shop}/admin/themes/current/editor?template=product` : '';
  const addUrl = `${editor}&addAppBlockId=${encodeURIComponent(`${apiKey}/cod-form`)}&target=mainSection`;
  return <>
    <Button onClick={async () => { if (!beforeOpen || await beforeOpen()) setOpen(true); }} disabled={disabled}>{t('Add to theme')}</Button>
    <Modal open={open} onClose={() => setOpen(false)} title={t('Add COD form to your theme')}
      primaryAction={available ? {content:t('Open theme editor'), url:addUrl, external:true} : undefined}
      secondaryActions={[{content:t('Cancel'), onAction:() => setOpen(false)}]}>
      <Modal.Section><BlockStack gap="300">
        <Text as="p">{t('Save your form settings first. In the theme editor, place the COD order form on the product template, then click Save.')}</Text>
        <Text as="p">{t('The editor opens in a new tab for your current published theme. Changes only take effect after you save the theme.')}</Text>
        <Text as="p">{t('Already added the form? Open the editor without adding another block.')}</Text>
        {available ? <Button url={editor} external>{t('Manage existing form')}</Button> : <Text as="p" tone="critical">{t('Open this app from Shopify admin to access your theme editor.')}</Text>}
      </BlockStack></Modal.Section>
    </Modal>
  </>;
}
